<div class="inventory-container">
  <!-- Header -->
  <div class="inventory-header">
    <h1 class="inventory-title">Add New User</h1>
    <div class="header-actions">
      <button
        (click)="goBack()"
        class="back-button"
      >
        ← Back to Users
      </button>
    </div>
  </div>

  <!-- Form Container -->
  <div class="form-container">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="user-form">
      
      <!-- Basic Information Section -->
      <div class="form-section">
        <h3 class="section-title">Basic Information</h3>
        
        <div class="form-row">
          <!-- User Code -->
          <!-- <div class="form-group">
            <label for="code" class="form-label">User Code *</label>
            <input
              type="text"
              id="code"
              formControlName="code"
              class="form-input"
              placeholder="Enter unique user code"
            />
            <div class="error-message" *ngIf="showError('code')">
              {{ getError('code') }}
            </div>
          </div> -->

          <!-- User Type -->
          <div class="form-group">
            <label for="type" class="form-label">User Type *</label>
            <select 
              id="type"
              formControlName="type"
              class="form-select"
            >
              <option value="">Select User Type</option>
              <option value="customer">Customer</option>
              <option value="admin">Admin</option>
              <option value="seller">Seller</option>
            </select>
            <div class="error-message" *ngIf="showError('type')">
              {{ getError('type') }}
            </div>
          </div>
        </div>

       <!-- في قسم Basic Information -->
<div class="form-row">
  <!-- Full Name -->
  <div class="form-group">
    <label for="name" class="form-label">Full Name *</label>
    <input
      type="text"
      id="name"
      formControlName="name"
      class="form-input"
      placeholder="Enter full name"
    />
    <div class="error-message" *ngIf="showError('name')">
      {{ getError('name') }}
    </div>
  </div>

  <!-- Phone -->
  <div class="form-group">
    <label for="phone" class="form-label">Phone Number *</label>
    <input
      type="tel"
      id="phone"
      formControlName="phone"
      class="form-input"
      placeholder="01XXXXXXXXX"
      pattern="[0-9]*"
      inputmode="numeric"
    />
    <div class="error-message" *ngIf="showError('phone')">
      {{ getError('phone') }}
    </div>
    <div class="phone-hint" *ngIf="!showError('phone')">
      Enter 11-digit Egyptian phone number starting with 01
    </div>
  </div>
</div>
      </div>

      <!-- Account Information Section -->
      <div class="form-section">
        <h3 class="section-title">Account Information</h3>
        
        <div class="">
          <!-- Email -->
            <label for="email" class="form-label">Email Address </label>
            <input
              type="email"
              id="email"
              formControlName="email"
              class="form-input"
              placeholder="Enter email address"
            />
            <div class="error-message" *ngIf="showError('email')">
              {{ getError('email') }}
            </div>
          
        </div>
          <div class="form-row">
          <!-- Password -->
          <div class="form-group">
            <label for="password" class="form-label">Password *</label>
            <input
              type="password"
              id="password"
              formControlName="password"
              class="form-input"
              placeholder="Enter password"
            />
            <div class="error-message" *ngIf="showError('password')">
              {{ getError('password') }}
            </div>
            <div class="password-hint">
              Password must be at least 6 characters long
            </div>
          </div>

            <!-- Confirm Password -->
            <div class="form-group">
                <label for="confirmPassword" class="form-label">Confirm Password *</label>
                <input
                type="password"
                id="confirmPassword"
                formControlName="confirmPassword"
                class="form-input"
                placeholder="Confirm password"
                [class.error]="showPasswordMismatchError()"
                />
                <!-- عرض إيرور تطابق الباسورد -->
                <div class="error-message" *ngIf="showError('confirmPassword')">
                {{ getError('confirmPassword') }}
                </div>
                <!-- عرض إيرور تطابق الباسورد على مستوى الفورم -->
                <div class="error-message" *ngIf="showPasswordMismatchError() && !showError('confirmPassword')">
                Passwords do not match
                </div>
            </div>

          
        </div>
      </div>

      <!-- Media & Status Section -->
      <div class="form-section">
        <h3 class="section-title">Media & Status</h3>
        
        <!-- <div class="form-row">
          <div class="form-group full-width">
            <label for="avatar" class="form-label">Profile Avatar</label>
            <div class="file-upload-container">
              <input
                type="file"
                id="avatar"
                (change)="onFileSelected($event)"
                accept="image/*"
                class="file-input"
              />
              <label for="avatar" class="file-upload-label">
                {{ selectedFileName || 'Choose avatar file...' }}
              </label>
            </div>
            <div class="file-hint">Supported formats: JPG, PNG, WebP (Max: 2MB)</div>
            <div class="error-message" *ngIf="showError('avatar')">
              {{ getError('avatar') }}
            </div>
            
            <div class="image-preview" *ngIf="imagePreview">
              <img [src]="imagePreview |ImageUrlPipe" alt="Preview" class="preview-image" />
              <button type="button" (click)="removeImage()" class="remove-image-btn">
                × Remove
              </button>
            </div>
          </div>
        </div> -->

        <!-- Toggle Switches -->
        <div class="toggle-section">
          <div class="toggle-row">
            <div class="toggle-group">
              <label class="toggle-label">Banned Status</label>
              <div class="toggle-container">
                <label class="switch-container">
                  <input 
                    type="checkbox" 
                    formControlName="banned"
                    class="toggle-switch"
                  />
                  <span class="slider"></span>
                </label>
                <span class="toggle-text">
                  {{ userForm.get('banned')?.value ? 'Banned' : 'Not Banned' }}
                </span>
              </div>
              <div class="toggle-description">
                User will be prevented from logging in
              </div>
            </div>

            <div class="toggle-group">
              <label class="toggle-label">Account Status</label>
              <div class="toggle-container">
                <label class="switch-container">
                  <input 
                    type="checkbox" 
                    formControlName="status"
                    class="toggle-switch"
                    [checked]="true"
                  />
                  <span class="slider"></span>
                </label>
                <span class="toggle-text">
                  {{ userForm.get('status')?.value ? 'Active' : 'Inactive' }}
                </span>
              </div>
              <div class="toggle-description">
                User account activation status
              </div>
            </div>
          </div>
        </div>

        <!-- User Type Description -->
        <div class="info-box" *ngIf="userForm.get('type')?.value">
          <h4>User Type Information:</h4>
          <div [ngSwitch]="userForm.get('type')?.value">
            <div *ngSwitchCase="'customer'">
              <strong>Customer:</strong> Can browse products, make purchases, and manage their orders.
            </div>
            <div *ngSwitchCase="'admin'">
              <strong>Admin:</strong> Has full access to the system including user management, product management, and system settings.
            </div>
            <div *ngSwitchCase="'seller'">
              <strong>Seller:</strong> Can manage their products, view sales reports, and handle orders for their products.
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          type="button"
          (click)="goBack()"
          class="cancel-button"
        >
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="userForm.invalid || isSubmitting"
          class="submit-button"
        >
          <span *ngIf="isSubmitting" class="loading-spinner"></span>
          {{ isSubmitting ? 'Creating User...' : 'Create User' }}
        </button>
      </div>
    </form>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-indicator">
    <div class="spinner"></div>
    <span>Loading form data...</span>
  </div>
</div>